import { mapGetters } from "vuex";
import event_bus from "../../shared/utils/event_bus";

export default {
  data() {
    return {
      marketdata_received: false,
    };
  },
  computed: {
    ...mapGetters({
      getSymbolPrice: "marketdata/getSymbolPrice",
      getSymbolData: "bests/getSymbolData",
    }),
  },
  methods: {
    pnl(order) {
      const obj = {
        difference: 0,
        result: 0,
      };

      const symbol = order.bo_symbol;
      const direction = order.bo_direction;
      const entry_price = order.bo_entry_price;
      const multiplier = order.bo_multiplier;
      const target_type = order.best_target_type;
      const current_price = this.getSymbolPrice(
        symbol,
        direction == "BUY" ? "bid_price" : "ask_price"
      );

      const symbol_data = this.getSymbolData.find(
        (item) => item.symbol == symbol
      );
      const {
        tick_size,
        tick_profit,
        symbol_market,
        decimal_places,
        min_volume,
      } = symbol_data;

      if (!this.marketdata_received || !entry_price || !current_price) {
        return obj;
      }

      if (order.closed_pnl) {
        obj.result = order.closed_pnl;
        if (order.bo_direction == "BUY") {
          if (obj.result > 0) {
            obj.difference = order.bo_target;
          } else {
            obj.difference = order.bo_target * -1;
          }
        } else {
          if (obj.result > 0) {
            obj.difference = order.bo_target * -1;
          } else {
            obj.difference = order.bo_target;
          }
        }
        return obj;
      }

      let difference = 0;
      if (direction == "BUY") {
        difference = current_price - entry_price;
      } else {
        difference = entry_price - current_price;
      }
      obj.difference = difference;

      if (symbol_market == "FUTURES") {
        obj.result = (difference / tick_size) * tick_profit * multiplier;
      } else if (target_type == "PERCENT") {
        obj.result = difference * min_volume * multiplier;
      }

      // (last_price * (target / 100) * min_volume * multiplier).toFixed(2);

      // if (symbol == 'BITFUT') {

      //   console.log(obj);
      // }

      return obj;
    },
  },

  mounted() {
    event_bus.$on("MARKET_DATA", () => {
      this.marketdata_received = true;
    });
  },
};
